var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadsetactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13867 10H6.88867C7.57903 10 8.13867 10.5596 8.13867 11.25V14.75C8.13867 15.4404 7.57903 16 6.88867 16H6.13867C4.48182 16 3.13867 14.6569 3.13867 13C3.13867 11.3431 4.48182 10 6.13867 10ZM6.13867 10V9C6.13867 5.68629 8.82496 3 12.1387 3C15.4524 3 18.1387 5.68629 18.1387 9V10M18.1387 10H17.3887C16.6983 10 16.1387 10.5596 16.1387 11.25V14.75C16.1387 15.4404 16.6983 16 17.3887 16H18.1387M18.1387 10C19.7955 10 21.1387 11.3431 21.1387 13C21.1387 14.6569 19.7955 16 18.1387 16M18.1387 16L17.5174 18.4851C17.2948 19.3754 16.4949 20 15.5771 20H13.1387",
    stroke: "#623CE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetactiveIcon);
export default __webpack_public_path__ + "static/media/headsetactiveIcon.889d6eb930d90b6d93d846aecb5166e5.svg";
export { ForwardRef as ReactComponent };